module.exports = __webpack_public_path__ + "img/yjh.c5a7ec1b.jpg";